import { render, staticRenderFns } from "./TeacherClassAmountList.vue?vue&type=template&id=c8e96868&scoped=true"
import script from "./TeacherClassAmountList.vue?vue&type=script&lang=js"
export * from "./TeacherClassAmountList.vue?vue&type=script&lang=js"
import style0 from "./TeacherClassAmountList.vue?vue&type=style&index=0&id=c8e96868&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e96868",
  null
  
)

export default component.exports